// BackgroundLayer.tsx
import React, { useState, useEffect } from 'react';
import './MagicBackground.css';
import StarsLayer from './StarsLayer';
import FirefliesLayer from './FirefliesLayer';
import CloudLayer from './CloudLayer';

const MagicBackground = React.memo(() => {
  const [mountKey, setMountKey] = useState(0);

  // Force remount of all layers when component mounts
  useEffect(() => {
    // Small delay to ensure proper cleanup
    const timer = setTimeout(() => {
      setMountKey(prev => prev + 1);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="background-container">
      <StarsLayer key={`stars-${mountKey}`} />

      {/* Moon Layer */}
      <div className="moon-layer">
        <div className="moon" />
        <div className="moon-glow" />
      </div>

      <CloudLayer key={`clouds-${mountKey}`} />

      <FirefliesLayer key={`fireflies-${mountKey}`} />
    </div>
  );
});

export default MagicBackground;
